import * as css from 'css/exports.module.scss';

import './EmailAlertRecipientsList.scss';

import { EmailAlertRecipientField } from './EmailAlertRecipientField';
import { PeriscopeSfEmailAlertRecipientField } from '@sonar-software/sonar-ts-types';
import React from 'react';
import { Space } from 'antd';

export interface EmailAlertRecipientFieldProps {
	parentIndex: number;
	recipients: PeriscopeSfEmailAlertRecipientField[];
}

export const EmailAlertRecipientsList: React.FC<EmailAlertRecipientFieldProps> = ({ parentIndex, recipients }) =>
	<Space
		className='email-alert-recipients'
		direction='vertical'
		size={ Number(css.size4) }>
		{ recipients.map(
			(record) => <EmailAlertRecipientField
				key={ record.recipient }
				parentIndex={ parentIndex }
				record={ record } />
		) }
	</Space>;

